import { render, staticRenderFns } from "./HeaderEdits.vue?vue&type=template&id=47840d14&scoped=true"
import script from "./HeaderEdits.vue?vue&type=script&lang=js"
export * from "./HeaderEdits.vue?vue&type=script&lang=js"
import style0 from "./HeaderEdits.vue?vue&type=style&index=0&id=47840d14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47840d14",
  null
  
)

export default component.exports